import { Button, CardActions, CardContent } from '@mui/material';

interface YesNoPopupProps {
    message: string,
    no: ()=>void,
    yes: ()=>void
}
export function YesNoPopup(YesNoPopupProps: YesNoPopupProps) {
  return (
    <div>
        <CardContent>
            <p>{ YesNoPopupProps.message }</p>
        </CardContent>
        <CardActions className='justify-between'>
            <Button size="small" color='error' onClick={YesNoPopupProps.no}>Non</Button>
            <Button size="small" color='info' onClick={YesNoPopupProps.yes}>Oui</Button>
        </CardActions>
    </div>
  );
}

export default YesNoPopup;